module.exports = __webpack_public_path__ + "img/Education Icon.84b1346d.svg";